<template>
  <div class="h-full">
    <el-row class="h-full w-full">
      <el-col :span="showControlPanel ? 18 : 24" class="h-full">
        <div class="w-full h-full">
          <EasyPlayer
            ref="easyPlayer"
            :videoUrl="videoUrl"
            :live="live"
            :muted="true"
            :show-custom-button="false"
            :reconnection="true"
            @error="errHandle"
            @pause="pauseCallback"
            @play="playCallback">
          </EasyPlayer>
        </div>
      </el-col>
      <el-col
        :span="showControlPanel ? 6 : 0"
        class="h-full pl-10px"
        element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="btnCont">
          <div>
            <div>云台控制</div>
            <div>
              <el-switch
                @change="changeMonitorStatus"
                v-model="isHistory"
                inactive-text="实时播放"
                active-text="历史播放">
              </el-switch>
            </div>
          </div>
          <div v-if="isHistory">
            <div class="flex items-center mt-10px" v-if="isSupportControl">
              <div>云台速：</div>
              <el-select
                popper-class="document_select-popper"
                v-model="historyParams.rate"
                size="mini"
                placeholder="请选择云台速度"
                style="width: 150px;"
              >
              <el-option
                v-for="item in rateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
              </el-select>
            </div>
            <div class="mt-10px">
              <el-date-picker size="mini" v-model="selectedDatetime" style="width: 100%;" type="datetimerange" placeholder="选择日期时间"></el-date-picker>
            </div>
            <el-row class="mt-10px">
              <el-button class="w-full" @click="startPlay()">开始回放</el-button>
              <!-- <el-button @click="stopPlay">停止回放</el-button> -->
            </el-row>
          </div>
          <div class="directionCont" v-if="!isHistory && isSupportControl">
            <div class="m-t-10">
              <div class="tc">
                <img
                  class="controlImg controlImg_up cursor-pointer"
                  src="@/assets/images/video-monitor/arrows.png"
                  @mousedown="ctrlDirection('start', 1)"
                  @mouseup="ctrlDirection('stop', 1)"
                />
              </div>
              <div class="tc flex justify-center">
                <img
                  class="controlImg cursor-pointer"
                  src="@/assets/images/video-monitor/arrows.png"
                  @mousedown="ctrlDirection('start', 3)"
                  @mouseup="ctrlDirection('stop', 3)"
                />
                <img
                  class="controlImg controlImg_right cursor-pointer"
                  src="@/assets/images/video-monitor/arrows.png"
                  @mousedown="ctrlDirection('start', 4)"
                  @mouseup="ctrlDirection('stop', 4)"
                />
              </div>
              <div class="tc">
                <img
                  class="controlImg controlImg_down cursor-pointer"
                  src="@/assets/images/video-monitor/arrows.png"
                  @mousedown="ctrlDirection('start', 2)"
                  @mouseup="ctrlDirection('stop', 2)"
                />
              </div>
            </div>
            <div class="mt-10px flex items-center">
              <div class="mr-10px">云台变速调</div>
                <el-button
                  icon="el-icon-zoom-in"
                  @mousedown.native="controlDistance('start', 1)"
                  @mouseup.native="controlDistance('stop', 1)"
                ></el-button>
                <el-button
                  icon="el-icon-zoom-out"
                  @mousedown.native="controlDistance('start', 4)"
                  @mouseup.native="controlDistance('stop', 4)"
                ></el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EasyPlayer from '@easydarwin/easyplayer'
import { UniSinSightCameraApi } from '@wiz-api/uni-sin-sight'
import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const uniSinSightCameraApi = new UniSinSightCameraApi()
const iOTDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()

export default {
  name: 'uniSinSight',
  components: { EasyPlayer },
  props: {
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // 是否显示云台和历史播放的操作面板;默认进来是实时播放模式，控制面板打开
    showControlPanel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isHistory: false,
      live: true,
      ApiHost: '',
      monitorTableLoading: false,
      historyParams: {
        rate: 0, // 回放倍数
        replay_id: '', // 回放id
      },
      selectedDatetime: [
        this.dayjs(new Date()).format('YYYY/MM/DD 00:00:00'),
        this.dayjs(new Date()).format('YYYY/MM/DD HH:mm:ss'),
      ], // 回放开始、结束时间
      rateList: [
        {
          value: -2,
          label: '0.5x',
        },
        {
          value: 0,
          label: '1x',
        },
        {
          value: 2,
          label: '2x',
        },
        {
          value: 4,
          label: '4x',
        },
      ],
      showPlayer: false,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
      },
      videoUrl: '',
      isPlaying: false,
      isSupportControl: false
    }
  },
  async mounted() {
    await this.hasControl()
    await this.getProtocalData()
    this.getRealTimeUrl()
  },
  methods: {
    errHandle(e) {
      console.log(e, '播放异常')
    },
    pauseCallback(e) {
      console.log(e, '播放暂停')
      this.isPlaying = false
    },
    playCallback(e) {
      console.log(e, '播放开始')
      this.isPlaying = true
    },
    // 是否有云台控制
    async hasControl() {
      const [err, res] = await uniSinSightCameraApi.supportPanTilt({
        channelCode: this.code,
      })
      if (!err) {
        if (res) {
          console.log(res, 'isSupportControl')
          this.isSupportControl = res
        }
      }
    },
    // 获取协议
    async getProtocalData() {
      const [err, res] = await iOTDeviceProtocolInstanceApi.getList({
        protocolCode: 'UniSinSight',
        skipCount: 0,
        maxResultCount: 15
      })
      if (!err) {
        if (res.items.length) {
          const jsonContent = res.items[0]?.jsonContent
          if (jsonContent) {
            const data = JSON.parse(jsonContent)
            this.ApiHost = data.ApiHost
          }
        }
      }
    },
    // 获取实时监控
    async getRealTimeUrl() {
      const [err, res] = await uniSinSightCameraApi.previewVideoStreamUrl({
        body: {
          channel_code: this.code,
          stream_type: 0,
          stream_mode: 3,
          visit_ip: this.ApiHost,
          h265_muxer_type: '0'
        }
      })
      if (!err) {
        console.log(res, '实时监控3')
        this.live = true
        this.videoUrl = res.data
      }
    },
    // 切换监控实时、历史
    changeMonitorStatus(isHistory) {
      this.onReset()
      if (isHistory) {
        this.startPlay()
      } else {
        this.getRealTimeUrl()
      }
    },
    // 开始回放
    startPlay() {
      if (!this.selectedDatetime || !this.selectedDatetime.length) {
        this.$message.warning('请先选择回放时间')
        return
      }
      this.getHistoryUrl()
    },
    // 获取历史监控
    async getHistoryUrl() {
      const [err, res] = await uniSinSightCameraApi.replayVideoStreamUrl({
        body: {
          channel_code: this.code,
          stream_mode: 3,
          visit_ip: this.ApiHost,
          start_time: this.dayjs(this.selectedDatetime[0]).valueOf(),
          end_time: this.dayjs(this.selectedDatetime[1]).valueOf(),
          source_type: 0,
          rate: this.historyParams.rate
        }
      })
      if (!err && res.data) {
        console.log(res, '历史监控3')
        this.live = false
        this.videoUrl = res.data.url
        this.historyParams.replay_id = res.data.replay_id
      }
    },
    // 播放倍数
    async rateChange() {
      const [err, res] = await uniSinSightCameraApi.replayVideoRate({
        body: {
          channel_code: this.code,
          replay_id: this.historyParams.replay_id,
          rate: this.historyParams.rate
        }
      })
      if (!err) {
        console.log('回放速度', res)
      }
    },
    // 控制云台的上下左右
    async ctrlDirection(command, direction) {
      let url = ''
      if (command === 'start') {
        url = 'cloudControlStart'
      } else {
        url = 'cloudControlStop'
      }
      const [err] = await uniSinSightCameraApi[url]({
        body: {
          channel_code: this.code,
          direction,
          speed: 4
        }
      })
      if (!err) {
        console.log(`旋转${command}`)
      }
    },

    // zoom 放大缩小倍数
    async controlDistance(command, operation) {
      let url = ''
      if (command === 'start') {
        url = 'cloudControlParamStart'
      } else {
        url = 'cloudControlParamStop'
      }
      const [err] = await uniSinSightCameraApi[url]({
        body: {
          channel_code: this.code,
          operation,
          speed: 4
        }
      })
      if (!err) {
        console.log(`缩放${command}`)
      }
    },
    // 重置
    onReset() {
      this.historyParams = {
        rate: 0,
        replay_id: ''
      }
      this.selectedDatetime = [this.dayjs(new Date()).format('YYYY/MM/DD 00:00:00'),
        this.dayjs(new Date()).format('YYYY/MM/DD HH:mm:ss')]
    },
  },
}
</script>

<style scoped lang="scss">
.btnCont {
  align-items: center;
}
.controlImg {
  width: 30px;
  &_up {
    transform: rotate(90deg);
  }
  &_right {
    margin-left: 30px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
  }
}
.tc {
  text-align: center;
  text-align: -webkit-center;
}
</style>
